import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { message } from "antd";

import { GetDecryptAccessTokenformat } from "../../Components/Common/Common";
import { ReGenerateToken } from "./authSlice";

const initialState = {
  isLoading: false,
  requestsList: [],
  AllUserDetails: null,
  plandetails: null,
  activePlanDetails: null,
  planhistory: null,
};

export const globalSlice = createSlice({
  name: "globalSlice",
  initialState,
  reducers: {
    SetLoading: (state, actions) => {
      state.isLoading = actions?.payload;
    },
    HandleAllUserRequestsList: (state, actions) => {
      state.requestsList = actions?.payload;
    },
    HandleAllUserDetails: (state, action) => {
      state.AllUserDetails = action?.payload;
    },
    HandleAllPlan: (state, action) => {
      state.plandetails = action?.payload;
    },
    HandleActivePlan: (state, action) => {
      state.activePlanDetails = action?.payload;
    },
    HandleAllPlanHistoryUser: (state, action) => {
      state.planhistory = action?.payload;
    },
    // Add a logout/reset reducer
    ResetGlobalStateRequestAuthSlice: () => initialState,
  },
});

export const {
  ResetGlobalStateRequestAuthSlice,
  HandleAllPlanHistoryUser,
  HandleActivePlan,
  HandleAllPlan,
  SetLoading,
  HandleAllUserRequestsList,
  HandleAllUserDetails,
} = globalSlice.actions;

export default globalSlice.reducer;

// REquets BLockchain API's

export function CreateRequest({ obj, page, limit, type }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/sendSolPrwRequest`;
      // const url = `https://fe86-110-227-190-178.ngrok-free.app/solana/api/sendSolPrwRequest`;

      const response = await axios.post(url, obj, reqoptions);

      if (response) {
        dispatch(SetLoading(false));
        dispatch(GetRequestsLists({ page, limit, type }));

        toast.success(response.data.message);
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, page, limit, type };
        // dispatch(ReGenerateToken(CreateRequest, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetRequestsLists({ page, limit, type }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/token-request-list?request_type=${type}&page=${page}&limit=${limit}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        dispatch(
          globalSlice?.actions?.HandleAllUserRequestsList(response?.data?.data)
        );
        message.success(response?.data?.message);
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        const body = { page, limit, type };
        dispatch(ReGenerateToken(GetRequestsLists, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function UpdateRequest({ obj, page, limit, type, navigate }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/handleTokenRequestAction`;
      // const url = `https://fe86-110-227-190-178.ngrok-free.app/solana/api/handleTokenRequestAction`;

      const response = await axios.post(url, obj, reqoptions);

      if (response) {
        sessionStorage?.clear();
        dispatch(GetRequestsLists({ page, limit, type }));
        dispatch(SetLoading(false));
        navigate("/getrequests");

        toast.success(response.data.message);

        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, page, limit, type };
        dispatch(ReGenerateToken(CreateRequest, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// *****************************************************************************************************

// ****************************************** OTP's API ''''''''''''''''''''''''''''''''''''''''''''

export function SendOTPToMail({
  obj,
  navigate,
  requestId,
  receiverWallet,
  currentPage
}) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/token-request-otp`;

      const response = await axios.post(url, obj, reqoptions);

      if (response) {
        sessionStorage.setItem("transferemail", obj?.email);
        sessionStorage.setItem("receiverWalletaddress", receiverWallet);
        sessionStorage.setItem("transferAmount", obj?.amount);
        sessionStorage.setItem("transferType", obj?.tokenType);
        sessionStorage.setItem("requestId", requestId);
        sessionStorage.setItem("OtpId", response?.data?.data?.otpId);
        sessionStorage.setItem("currentPage", currentPage);
        
        dispatch(SetLoading(false));
        toast.success(response.data.message);
        navigate("/otp-consent");
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj, navigate };
        dispatch(ReGenerateToken(SendOTPToMail, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function TransferTokensToUser({ obj, navigate }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/transfer-token`;
      // const url = `https://fe86-110-227-190-178.ngrok-free.app/solana/api/transfer-token`;

      const response = await axios.post(url, obj, reqoptions);

      if (response) {
        sessionStorage.clear();
        dispatch(SetLoading(false));
        toast.success(response.data.message);
        navigate("/walletdetails");
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj };
        dispatch(ReGenerateToken(TransferTokensToUser, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetAllUserDetails({ page, limit, search }) {
  const token = GetDecryptAccessTokenformat();

  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      // dispatch(SetLoading(true));
      let url = search
        ? `${
            process.env.REACT_APP_apiBaseUrlSolana
          }/admin/api/v1/listAllApplicationUser?page=${page}&limit=${limit}&search=${
            search || null
          }`
        : `${process.env.REACT_APP_apiBaseUrlSolana}/admin/api/v1/listAllApplicationUser?page=${page}&limit=${limit}`;
      // let url = search
      //   ? `http://192.168.29.219:5001/api/v1/listAllApplicationUser?page=${page}&limit=${limit}&search=${
      //       search || null
      //     }`
      //   : `http://192.168.29.219:5001/api/v1/listAllApplicationUser?page=${page}&limit=${limit}`;
      const response = await axios.get(url, reqoptions);

      if (response?.data) {
        dispatch(globalSlice?.actions?.HandleAllUserDetails(response?.data));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { page, limit, search };
        // dispatch(ReGenerateToken(GetAllUserDetails, body, dispatch));
        return;
      }

      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function ReSendOTPToMail({ obj }) {
  const token = GetDecryptAccessTokenformat();
  const reqoptions = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/resend-token-requestOtp`;

      const response = await axios.post(url, obj, reqoptions);

      if (response) {
        sessionStorage.setItem("OtpId", response?.data?.data?.otpId);

        dispatch(SetLoading(false));
        toast.success(response.data.message);
        return response.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        let body = { obj };
        dispatch(ReGenerateToken(ReSendOTPToMail, body, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetPlans() {
  const token =
    GetDecryptAccessTokenformat() || localStorage.getItem("access_token");
  const reqOptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/admin/api/v1/getPlan`;
      // const url = `http://192.168.29.219:5001/api/v1/getPlan`;
      dispatch(SetLoading(true));
      const response = await axios.get(url, reqOptions);

      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(globalSlice.actions.HandleAllPlan(response?.data?.data));
        return response.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        dispatch(ReGenerateToken(GetPlans, {}, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetActivePlanDetails() {
  const token =
    GetDecryptAccessTokenformat() || localStorage.getItem("access_token");
  const reqOptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/plans/get-plan`;
      // const url = `http://192.168.29.219:5090`;
      dispatch(SetLoading(true));

      const response = await axios.get(url, reqOptions);

      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(globalSlice.actions.HandleActivePlan(response?.data?.data || []));
        return response.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        dispatch(ReGenerateToken(GetActivePlanDetails, {}, dispatch));
        return;
      }
      // toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

export function GetUserPlanHistory({ page, limit }) {
  const token =
    GetDecryptAccessTokenformat() || localStorage.getItem("access_token");

  const reqOptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/plans/payment-history?page=${page}&limit=${limit}`;
      // const url = `http://192.168.29.219:5090/payment-history?page=${page}&limit=${limit}`;

      const response = await axios.get(url, reqOptions);

      if (response?.data) {
        dispatch(SetLoading(false));
        dispatch(
          globalSlice.actions.HandleAllPlanHistoryUser(response?.data?.data)
        );
        return response.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      if (error?.response?.status === 401) {
        dispatch(
          ReGenerateToken(GetUserPlanHistory, { page, limit }, dispatch)
        );
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// GET SOLANA MAINDUMMY ACCOUNT WALLET FOR SENDING SOL

export function GetMainSolanaWalletBalance() {
  const token =
    GetDecryptAccessTokenformat() || localStorage.getItem("access_token");

  const reqOptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/platform-sol-balance`;

      const response = await axios.get(url, reqOptions);

      if (response?.data) {
        dispatch(SetLoading(false));
        return response.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
        if (error?.response?.status === 401) {
        dispatch(ReGenerateToken(GetMainSolanaWalletBalance, {}, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// BUY SOL API
export function PostBuySOL({ obj }) {
  const token =
    GetDecryptAccessTokenformat() || localStorage.getItem("access_token");

  const reqOptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));
      const url = `${process.env.REACT_APP_apiBaseUrlSolana}/solana/api/buy-sol`;

      const response = await axios.post(url, obj, reqOptions);

      if (response?.data) {
        dispatch(SetLoading(false));
        return response.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
       if (error?.response?.status === 401) {
        let body={obj}
        dispatch(ReGenerateToken(PostBuySOL, {body}, dispatch));
        return;
      }
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}
